import React, { useState } from 'react'
import './slider-galery.scss';

import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation } from 'swiper';
import PreviewYoutube from '../preview-youtube/preview-youtube';

SwiperCore.use([Navigation]);

const SliderGalery = props => {
    const { images, maxShow, youtube, title } = props;
    const [ slider, setSlider ] = useState(null);
    const [ activeIndex, setActiveIndex ] = useState(0);

    const handleSlideChange = (e ) => {
        console.log('nuevo',e.activeIndex)
    }

    const max = images.length + ( youtube ? 1 : 0 );

    return (
        <div className="a-slider-galery">
            <Swiper
                onActiveIndexChange={ (e) => setActiveIndex( e.activeIndex ) }
                slidesPerView={'auto'}
                className={"swiper-my "}
                onSwiper={ setSlider }
            >
                {
                    images &&
                    images.slice(0, maxShow ? maxShow : images.length).map((imagen, index) => [
                        <SwiperSlide key={index}>
                            <div className="a-card-sale-img">
                                <img src={ imagen.file.url } alt={ "imagen de " + (title ? title + " " : '')  +  (index + 1) } title={ title }/>
                            </div>
                        </SwiperSlide>
                    ])
                }
                {
                    youtube &&
                    <SwiperSlide>
                        <PreviewYoutube info={ youtube }/>
                    </SwiperSlide>
                }
            </Swiper>
            { 
                (max > 1 && activeIndex > 0 ) &&
                <div className="a-slider-galery-arrow prev" onClick={() => slider.slidePrev()}>
                    <i className="fal fa-arrow-left"></i>
                </div>
            }
            
            { 
                (max > 1 && activeIndex < max - 1 ) &&
                <div className="a-slider-galery-arrow next" onClick={() => slider.slideNext()}>
                    <i className="fal fa-arrow-right"></i>
                </div>
            }
        </div>
    )
}

export default SliderGalery
